function parseEndHour(end) {
    const match = /^(\d{1,2}):(\d{2})$/.exec(end.trim());
    if (!match)
        return null;
    const hour = Number.parseInt(match[1], 10);
    if (!Number.isFinite(hour) || hour < 0 || hour > 23)
        return null;
    return hour;
}
/** Primary headline when quiet hours are active. */
export function quietHoursHeadline({ end, endsAtLabel }) {
    const hour = parseEndHour(end);
    if (hour !== null && hour < 12) {
        return "Resting until morning.";
    }
    return `Resting until ${endsAtLabel}.`;
}
/** Supporting copy under the headline. Wake time lives in the status pill. */
export function quietHoursSupportingCopy() {
    return "Your heartbeat is quiet. HealthOS is still listening in the background.";
}
//# sourceMappingURL=quiet-hours-copy.js.map